import { DEVICE_BATCHES_PATH } from 'production/navigation';

const indexComponent = require('./routes/list/components/DeviceBatchesList');

const indexRoute = {
  component: indexComponent,
};

module.exports = {
  path: DEVICE_BATCHES_PATH,
  getChildRoutes(partialNextState, cb) {
    require.ensure([], (require) => {
      cb(null, [
        require('./routes/add'),
        require('./routes/show'),
      ]);
    });
  },
  getIndexRoute(partialNextState, cb) {
    require.ensure([], () => {
      cb(null, indexRoute);
    });
  },
  getComponent(nextState, cb) {
    require.ensure([], (require) => {
      cb(null, require('./components/DeviceBatchesManager'));
    });
  },
};



// WEBPACK FOOTER //
// ./routes/app/routes/production/routes/deviceBatches/index.js